// extracted by mini-css-extract-plugin
export default {"section":"Contact_section__TLIx5","title":"Contact_title__1Oox5","card":"Contact_card__mpcf6","iconWrapper":"Contact_iconWrapper__J2QES"};